import httpClient from 'axios'
import _, { forEach } from 'lodash'
import store from '../vuex/store'
import axios from 'axios'
import qs from 'qs'
import crypto from 'crypto';

var Buffer = require('buffer/').Buffer

class BasicClient {

    static axiosInstance = axios
    exec(urlSet, methods, paramsSet, flagForParam) {
        let data
        let header = {}
        if (paramsSet !== undefined) {
            if (_.includes(['POST', 'PATCH', 'PUT', 'DELETE'], methods)) {
                //Saque el PUT de aca.
                const params = flagForParam ? new FormData() : new URLSearchParams()
                for (let name in paramsSet) {
                    if (paramsSet.hasOwnProperty(name)) {
                        let param = paramsSet[name]
                        if (typeof param === 'object' && !(param instanceof Blob)) {
                            param = JSON.stringify(paramsSet[name])
                        }
                        params.append(name, param)
                    }
                }
                data = { data: params }
            } else {
                data = { params: paramsSet }
            }
        }

        const Authorization = store.state.jwt ?
            store.state.jwt :
            localStorage.getItem('jwt')

        header = { headers: { Authorization: 'Bearer ' + Authorization } }

        if (flagForParam) {
            header.headers['Content-Type'] = 'multipart/form-data'
        }

        return httpClient.request(
            _.assignIn({
                    url: urlSet,
                    method: methods,
                    baseURL: window.sichern.apiURL
                        // headers: header
                },
                data,
                header
            )
        )
    }
    exec2(urlSet, body) {
        const formData = new FormData();
    
        formData.append('idabsence', body.idabsence);
        formData.append('template', JSON.stringify(body.template));
        if (Array.isArray(body.file) && body.file.length > 0) {
            body.file.forEach((file, index) => {
                if (file.file && file.file instanceof Blob) {
                    formData.append('file[]', file.file, file.name);
                } else {
                    throw new Error(`File at index ${index} is not a valid Blob.`);
                }
            });
        } else {
            throw new Error("The 'file' field must be an array with at least one element.");
        }
    
        const Authorization = store.state.jwt ?
            store.state.jwt :
            localStorage.getItem('jwt');
    
        const header = {
            headers: {
                Authorization: 'Bearer ' + Authorization,
                'Content-Type': 'multipart/form-data'
            }
        };
        return httpClient.request({
            url: urlSet,
            method: 'POST',
            baseURL: window.sichern.apiURL,
            data: formData,
            ...header
        });
    }
    getImage(apiEndpoint) {
        const Authorization = store.state.jwt ?
            store.state.jwt :
            localStorage.getItem('jwt')
        return axios
            .get(window.sichern.apiURL + apiEndpoint, {
                responseType: 'arraybuffer',
                headers: { Authorization: 'Bearer ' + Authorization }
            })
            .then(response => new Buffer(response.data, 'binary').toString('base64'))
    }
    
    getPublicImage(id_company) {
        const random = '?v=' + new Date().getTime()
        function md5(str) {
            const hash = crypto.createHash('md5');
            hash.update(str);
            return hash.digest('hex');
          }
        
        const id_company_md5 ='/' + md5(id_company.toString()) 
        const baseUrl = window.sichern.publicDevURL || window.sichern.apiURL
        return   `${baseUrl}/company/logo/${id_company + id_company_md5 + random}`
    }

    getArrayBuffer(endpoint) {
        const Authorization = store.state.jwt ?
            store.state.jwt :
            localStorage.getItem('jwt')
        return axios.get(window.sichern.apiURL + endpoint, {
            responseType: 'arraybuffer',
            headers: { Authorization: 'Bearer ' + Authorization }
        })
    }
    getImageWithResponse(apiEndpoint) {
        const Authorization = store.state.jwt ?
            store.state.jwt :
            localStorage.getItem('jwt');
            
        const url = new URL(apiEndpoint, window.sichern.apiURL);
    
        return axios
            .get(url.toString(), {
                responseType: 'arraybuffer',
                headers: { Authorization: 'Bearer ' + Authorization }
            })
            .then(response => {
                return [
                    response,
                    Buffer.from(response.data, 'binary').toString('base64')  
                ];
            });
    }
    downloadFile(apiUrl, inputParams) {
        const params = new FormData()

        forEach(inputParams, (value, key) => {
            let param = value
            if (typeof param === 'object' && !(param instanceof Blob)) {
                param = JSON.stringify(value)
            }
            params.append(key, param)
        })

        return axios.post(window.sichern.apiURL + apiUrl, params, {
            responseType: 'blob',
            headers: { Authorization: 'Bearer ' + store.getters.getJwt }
        })
    }

    downloadAudioFile(apiUrl,method,params) {
        let jwt = store.state.jwt ?
        store.state.jwt :
        localStorage.getItem('jwt')
        return axios.get(window.sichern.apiURL + apiUrl, {
            responseType: 'blob',
            headers: { Authorization: 'Bearer ' + jwt},
            params: params,
        })
    }

    getDownloadBlobFile(apiUrl, params) {
        return axios.post(window.sichern.apiURL + apiUrl, params, {
            responseType: 'blob',
            headers: { Authorization: 'Bearer ' + store.getters.getJwt }
        })
    }

    loadUrl(jwtEforms, fullName, hash) {
        const data = qs.stringify({ jwt: jwtEforms, fullname: fullName })
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        }
        return axios
            .post(
                window.sichern.eformsURL + '/template/view/' + hash,
                data,
                config
            )
            .then(response => {
                return response
            })
            .catch(error => {
                return error
            })
    }
    getFileJson(urlFile) {
        return axios
            .get(urlFile, {
                responseType: 'json',
                xsrfCookieName: 'XSRF-TOKEN',
                xsrfHeaderName: 'X-XSRF-TOKEN',
                headers: {
                    Accept: 'application/json; odata=verbose'
                }
            })
            .then(response => {
                return response
            })
            .catch(error => {
                if (!error.response) {
                    //axios network error not controller
                } else {
                    return error
                }
            })
    }
    execLogoutSAML(urlSet, methods, paramsSet) {
        let params = new URLSearchParams()
        for (let name in paramsSet) {
            if (paramsSet.hasOwnProperty(name)) {
                let param = paramsSet[name]
                if (typeof param === 'object' && !(param instanceof Blob)) {
                    param = JSON.stringify(paramsSet[name])
                }
                params.append(name, param)
            }
        }
        let data = { data: params }
        let header = {}
        return httpClient.request(
            _.assignIn({
                    url: urlSet,
                    method: methods,
                    baseURL: window.sichern.apiURL
                },
                data,
                header
            )
        )
    }
    requestWithoutJWT(endpoint, method, paramsSet, flagForParam) {
        let data
        if (paramsSet !== undefined) {
            if (_.includes(['POST', 'PATCH', 'PUT', 'DELETE'], method)) {
                const params = flagForParam ? new FormData() : new URLSearchParams()
                for (let name in paramsSet) {
                    if (paramsSet.hasOwnProperty(name)) {
                        let param = paramsSet[name]
                        if (typeof param === 'object' && !(param instanceof Blob)) {
                            param = JSON.stringify(paramsSet[name])
                        }
                        params.append(name, param)
                    }
                }
                data = { data: params }
            } else {
                data = { params: paramsSet }
            }
        }
        return axios
            .request(
                _.assignIn({
                        url: endpoint,
                        method: method,
                        baseURL: window.sichern.apiURL
                    },
                    data
                )
            )
    }

    makeRequest({ method, url, data, headers = {}, withAuth = false }) {
        return httpClient.request({
            baseURL: window.sichern.apiURL,
            headers: {
                ...( withAuth ? { Authorization: 'Bearer ' + this.getToken() } : {}),
                ...headers,
            },
            data,
            method,
            url,
        });
    }

    getToken() {
        return store.state.jwt
            ? store.state.jwt
            : localStorage.getItem('jwt')
    }

    renderImage(apiEndpoint) {
        return axios
            .get(window.sichern.apiURL + apiEndpoint, {
                responseType: 'arraybuffer',
                headers: { Authorization: 'Bearer ' + this.getToken() },
            })
            .then((response) => {
                return new Buffer(response.data, 'binary').toString('base64')
            })
    }
}

export { BasicClient }